import { useEffect } from 'react';
import { useToaster } from './ui/Toaster';
import {
  retryPublicProfileSyncNow,
  subscribePublicProfileSyncNotices,
} from '../lib/publicProfileSyncFeedback';

/**
 * Mounted once, inside ToasterProvider. Turns public-profile copy failures from any save
 * (lib/publicProfileSyncFeedback.ts) into one calm toast with a "Retry now" button.
 * Renders nothing itself.
 */
export default function PublicProfileSyncNotices() {
  const { push } = useToaster();

  useEffect(
    () =>
      subscribePublicProfileSyncNotices((notice) => {
        if (notice.kind === 'failed') {
          push({
            title: 'Saved',
            description: 'Your public profile did not update. We will retry.',
            testId: 'public-profile-sync-failed',
            action: {
              label: 'Retry now',
              testId: 'public-profile-sync-retry',
              onClick: () => {
                void retryPublicProfileSyncNow(notice.uid);
              },
            },
          });
        } else if (notice.kind === 'recovered') {
          push({ title: 'Public profile updated', testId: 'public-profile-sync-recovered' });
        } else {
          push({
            title: 'Your public profile is not updated yet',
            description: 'Your changes are saved. Employers may see your older details until your next save goes through.',
            testId: 'public-profile-sync-gave-up',
          });
        }
      }),
    [push]
  );

  return null;
}
